<template>
  <div class="div-table-row">
    <slot />
  </div>
</template>

<style lang="scss">
.div-table-row {
  display: grid;
  align-items: stretch;
}
</style>
